import {CLCopilotContext} from 'common/src/modules/shared/copilot/bootstrap/bootstrap.types';

function formatMovieCompositionContext(
  _prevContext: CLCopilotContext | null,
  _currentContext: CLCopilotContext,
): string | null {
  // no context formatter for this context entry - everything relies on tools
  return null;
}

export default formatMovieCompositionContext;
